import React, { useState } from 'react';
import _ from 'lodash';
import classes from './index.css';
import TransitionExpand from './TransitionExpand';

export default function WorkroleComps(props){

    const [showDetails, setShowDetails] = useState(() => {
        if(props.comps){
            var temp = {};
            Object.keys(props.comps).forEach(compid => temp[compid]=false);
            return temp;
        }else{
            return [];
        }
    });
    const [keywords, setKeywords] = useState("");
    const [hasAssessed, setHasAssessed] = useState(false);
    const [hasPracticed, setHasPracticed] = useState(false);
    const [hasExposure, setHasExposure] = useState(true);
    
    // console.log('showDetails');
    // console.log(showDetails);

    
    // console.log('workrole comps props');
    // console.log(props);

    const toggleTableDetails = (compid) =>{
        var showdeets = _.cloneDeep(showDetails);
        showdeets[compid] = !showdeets[compid];
        if(!_.isEqual(showdeets, showDetails)) setShowDetails(showdeets);
    }

    const filterComps = () =>{
        setKeywords("");
    }
    const checkShowComp = (row) => {
        if(keywords.length){
            let regexp=new RegExp(keywords.replaceAll(' ', '|'), "i")
            let comp= props.competencies[row.id]
            if(regexp.test(`${comp.idnumber} ${comp.description}`)){
                let hasAssessedTemp = !hasAssessed || Object.keys(row.assessed.courses).length > 0
                let hasPracticedTemp = !hasPracticed || Object.keys(row.practiced.courses).length > 0
                let hasExposureTemp = !hasExposure || Object.keys(row.exposed.courses).length > 0
                return hasAssessedTemp || hasPracticedTemp || hasExposureTemp

            } else {
                return false
            }
        }

        let passesAssessed = !hasAssessed || (hasAssessed && Object.keys(row.assessed.courses).length > 0)
        let passesPracticed = !hasPracticed || (hasPracticed && Object.keys(row.practiced.courses).length > 0)
        let passesExposure = !hasExposure || (hasExposure && Object.keys(row.exposed.courses).length > 0)

       
        return passesAssessed && passesPracticed && passesExposure;
    }

    const clearActivityFilter = () =>{
        setHasAssessed(false);
        setHasExposure(false);
        setHasPracticed(false);
    }
    const getFilterActive = (type) => {
        if (type){
            return classes.filterActive;
        }
        return "";
    }

    const getTableData = () => {
        let tableData = []
        let wrCompArr=Object.values(props.comps)
        wrCompArr.forEach(compid => {
            let comp=props.competencies[compid]
            tableData.push({
                id: compid,
                idnumber: comp.idnumber,
                description: comp.description,
                practiced: {
                    courses: {},
                    mods: {},
                },
                assessed: {
                    courses: {},
                    mods: {},
                },
                exposed: {
                    courses: {},
                    mods: {},
                }
            })
        })
        let assessmentTagList=["Assessment", "Test", "assessment", "test"]
        Object.values(props.courses).forEach(crs =>{
            let crsCompArr=[]
            crs.competencies.forEach(compid => crsCompArr.push(`${compid}`))
            let overlap = wrCompArr.filter(x => crsCompArr.includes(x))
            Object.values(crs.course_modules).forEach(cm => {
                let info=cm.cm_info
                let modCompArr = []
                Object.values(cm.competencies).forEach(compid => {
                    modCompArr.push(`${compid}`)
                })
                let modOverlap = modCompArr.filter(x => wrCompArr.includes(x))
                let isAssessment = false;
                Object.values(info.tags).forEach(tag => {
                    if(assessmentTagList.includes(tag)) {
                        isAssessment=true;
                    }
                })
                let isPractice=false
                if(info.modname != "resource") {
                    isPractice=true
                }
                modOverlap.forEach(compid =>{
                    let tableRow = tableData.filter(x => x.id==compid)[0]
                    if(isPractice){
                        tableRow.practiced.mods[cm.id]=info
                        if(!tableRow.practiced.courses[crs.id]){
                            tableRow.practiced.courses[crs.id]=crs
                        }
                    }
                    if(isAssessment){
                        tableRow.assessed.mods[cm.id]=info
                        if(!tableRow.assessed.courses[crs.id]){
                            tableRow.assessed.courses[crs.id]=crs
                        }
                    }
                    tableRow.exposed.mods[cm.id]=info
                    if(!tableRow.exposed.courses[crs.id]){
                        tableRow.exposed.courses[crs.id]=crs
                    }
                })
                
            })
        })
        tableData.sort((a,b) => {
            if (a.idnumber < b.idnumber){
                return -1
            }
            if (b.idnumber < a.idnumber){
                return 1
            }
            return 0
        })
        tableData.sort((a,b) => {
            return (
                Object.keys(b.exposed.mods).length +
                Object.keys(b.practiced.mods).length +
                Object.keys(b.assessed.mods).length
            ) - (
                Object.keys(a.exposed.mods).length +
                Object.keys(a.practiced.mods).length +
                Object.keys(a.assessed.mods).length
            )
        })
        return tableData
    }

    let tableData = getTableData();
    console.log('workrole comps table data');
    console.log(tableData);

    return(
        <div className={classes.wrCompdetails}>
            <h5>{props.wr.name} Competencies</h5>
            <div className={classes.compFilters}>
                <form
                    autoComplete="off"
                    onSubmit={e => e.preventDefault()}
                >
                    <div className={classes.keywordsearch}>
                        <input type="text" name="Search" placeholder="Keyword fiilter"  
                            value={keywords}
                            onChange={e => setKeywords(e.target.value)}
                        />
                        <input type="submit" value="Clear" onClick={(e) => { e.preventDefault(); filterComps()}}/>
                    </div>                    
                    <div className={classes.countfilter}>
                        Only show Competencies with:
                        <div className={classes.activitygroup}>
                            <div className={classes.activityCountFilter + ' ' + getFilterActive(hasExposure)}
                                onClick={() => setHasExposure(!hasExposure)}
                            >
                                Exposure
                            </div>
                            <div className={classes.activityCountFilter + ' ' + getFilterActive(hasPracticed)}
                                onClick={() => setHasPracticed(!hasPracticed)}
                            >
                                Practice
                            </div>
                            <div className={classes.activityCountFilter + ' ' + getFilterActive(hasAssessed)}
                                onClick={() => setHasAssessed(!hasAssessed)}
                            >
                                Assessments
                            </div>
                            <div className={classes.activityCountFilter + ' ' + getFilterActive(!(hasExposure || hasPracticed || hasAssessed))}
                                onClick={() => clearActivityFilter()}
                            >
                                Show All Workrole Competencies
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            {Object.keys(tableData).map(tableRowId => {
                var tableRow= tableData[tableRowId];
                var extraClass = showDetails[tableRow.id] ? classes.wrComplistExpanded : "";
                return(
                    <div key={tableRow.id} 
                    className={classes.wrComplist + ' ' + extraClass}
                    title={tableRow.description}
                    onClick={() => toggleTableDetails(tableRow.id)}
                    >
                        {checkShowComp(tableRow) &&
                            (
                            <TransitionExpand duration={500} height={checkShowComp(tableRow) ? 'auto' : 0}>
                                <div className={classes.notThere}>
                                    <div className={classes.complistFirstline}>
                                        <div className={classes.complistIdNumber}> {tableRow.idnumber}</div>
                                        <div className={classes.compsExposed}>E: {Object.values(tableRow.exposed.mods).length}</div> 
                                        <div className={classes.compsPracticed}>P: {Object.values(tableRow.practiced.mods).length}</div> 
                                        <div className={classes.compsAssessed}>A: {Object.values(tableRow.assessed.mods).length}</div> 
                                    </div>
                                    {showDetails[tableRow.id] ? 
                                        <div className={classes.complistDetails}>
                                            {tableRow.description}
                                        </div>
                                    :
                                        <div className={classes.compDesc}>
                                            {tableRow.description}
                                        </div>
                                    }
                                </div>
                            </TransitionExpand>
                            )   
                        }
                    </div>
                )

            })}
        </div>
    )
}
